import React, { FC, useEffect, useState } from 'react';
import { Button, Dropdown, Radio, RadioChangeEvent } from 'antd';
import { DEFAULT_VALUE_1 } from 'common/config';
import { Minus, Plus } from 'common/svg';
import { countFormatter } from 'common/helpers';
import {
  IInventoryAssignee,
  IAddInventoryAssigneePayload,
  IRemoveInventoryAssigneePayload,
} from 'entities/Inventory/Inventory.models';

interface IComponentProps {
  inventoryId: number;
  assignee: IInventoryAssignee;
  disabled: boolean;
  updateAssignee: (payload: IAddInventoryAssigneePayload) => Promise<void>;
  removeAssignee: (payload: IRemoveInventoryAssigneePayload) => Promise<void>;
}

export const InventoryAssigneeUnassignBtn: FC<IComponentProps> = (props) => {
  const { inventoryId, assignee, disabled, updateAssignee, removeAssignee } = props;

  const [count, setCount] = useState<number>(DEFAULT_VALUE_1);
  const [option, setOption] = useState<'fully' | 'partially'>('fully');

  useEffect(() => {
    setCount(assignee.count);
  }, [assignee]);

  const onOpenDropdownChange = (value: boolean) => {
    if (value) {
      setOption('fully');
    }
  };

  const onRadioChange = (e: RadioChangeEvent) => {
    const value = e.target.value;

    setOption(e.target.value);

    if (value === 'partially') {
      setCount(assignee.count);
    }
  };

  const onDecreaseClick = () => {
    setCount((prev) => prev - DEFAULT_VALUE_1);
  };

  const onIncreaseClick = () => {
    setCount((prev) => prev + DEFAULT_VALUE_1);
  };

  const onUnassignClick = async () => {
    if (count === assignee.count) {
      await removeAssignee({ inventoryId, assigneeId: assignee.id });
    } else {
      await updateAssignee({ inventoryId, assigneeId: assignee.id, count: assignee.count - count });
    }
  };

  return (
    <Dropdown
      overlayClassName="redesign"
      trigger={['click']}
      placement="topLeft"
      disabled={disabled}
      onOpenChange={onOpenDropdownChange}
      menu={{
        items: [
          { type: 'divider' },
          {
            key: 'unassign',
            label: 'Открепить оборудование',
            className: 'red',
            onClick: onUnassignClick,
          },
        ],
      }}
      dropdownRender={(menu) => {
        return (
          <div className="custom-dropdown">
            <Radio.Group
              className="flex direction-column"
              style={{ gap: 16 }}
              value={option}
              onChange={onRadioChange}
              options={[
                { value: 'fully', label: 'Полностью' },
                { value: 'partially', label: 'Только часть', disabled: assignee.count === DEFAULT_VALUE_1 },
              ]}
            />

            {option === 'partially' && (
              <div className="flex align-center mt-5">
                <Button
                  className="inventory-card__assignee-counter-btn"
                  icon={<Minus className="icon-minus-dark-grey" />}
                  onClick={onDecreaseClick}
                  disabled={count === DEFAULT_VALUE_1}
                />

                <div className="ff-regular fs-s mx-6">{countFormatter(count)}</div>

                <Button
                  className="inventory-card__assignee-counter-btn"
                  icon={<Plus className="icon-plus-dark-grey" />}
                  onClick={onIncreaseClick}
                  disabled={count === assignee.count}
                />
              </div>
            )}

            {menu}
          </div>
        );
      }}
    >
      <Button className="button-sm deleting">Открепить</Button>
    </Dropdown>
  );
};
